import { Typography } from '@mui/joy';
import { CSSProperties } from 'react';

import PreviewCsv from 'assets/previewCsv.svg';
import PreviewXls from 'assets/previewXls.svg';
import PreviewZip from 'assets/previewZip.svg';
import { PdfThumbnail } from 'core/components';
import { MimeType } from 'core/enums';

import Image from './Image';

type PreviewRendererProps = {
  fileType: MimeType;
  fileUrl: string;
  fileName: string;
  onSelect?: () => void;
  previewStyle?: CSSProperties;
};

export const FilePreview = ({
  fileType,
  fileUrl,
  fileName,
  onSelect,
  previewStyle,
}: PreviewRendererProps) => {
  switch (fileType) {
    case MimeType.PDF:
      return (
        <PdfThumbnail
          fileUrl={fileUrl}
          onClick={onSelect}
          wrapperSxProps={{ ...previewStyle, cursor: 'pointer' }}
        />
      );
    case MimeType.XLS:
    case MimeType.XLSX:
      return <Image src={PreviewXls} style={previewStyle} />;
    case MimeType.GIF:
    case MimeType.JPEG:
    case MimeType.PNG:
    case MimeType.SVG:
      return (
        <Image
          src={fileUrl}
          onClick={onSelect}
          alt={fileName}
          style={{ ...previewStyle, cursor: 'pointer' }}
        />
      );
    case MimeType.CSV:
      return (
        <Image
          src={PreviewCsv}
          onClick={onSelect}
          alt={fileName}
          style={{ ...previewStyle, cursor: 'pointer' }}
        />
      );
    case MimeType.ZIP:
      // Non-interactive icon (matches XLS): zip has no preview modal, so no onClick/cursor.
      return <Image src={PreviewZip} style={previewStyle} />;
    default:
      return <Typography sx={{ wordBreak: 'break-word' }}>{fileName}</Typography>;
  }
};
